import React from 'react';
import PasswordStrengthHint from './PasswordStrengthHint';
import { GoogleSignInButton, AuthDivider } from './Login';

/**
 * Step 1 of signup: just email + password.
 * After submit, the caller transitions to SignupStep2 for profile fields.
 */
export default function SignupStep1({
  form,
  setForm,
  onSubmit,
  onSwitchToLogin,
  onForgotPassword,
  onGoogleSignIn,
  error,
  loading,
  invite = null, // { email, companyName, inviterName } | null — when present,
                 // the user arrived via /?invite=TOKEN; show a banner and
                 // lock the email field to the invited address.
}) {
  const isInvited = !!invite;

  return (
    <div className="auth-view">
      <div className="hero">
        <h2>{isInvited ? `Join ${invite.companyName}` : 'Create your account'}</h2>
        <p>
          {isInvited
            ? `${invite.inviterName || 'Your teammate'} invited you to join their team on TrailerCast. Set a password or continue with Google to accept.`
            : 'Get started for free. No credit card required.'}
        </p>
      </div>

      {/* Google sign-up. Skipped when the invite is locked to a
          specific email — Google might sign them in with a different
          account, dropping the invite. The password flow guarantees
          the right email lands on the right team. */}
      {onGoogleSignIn && !isInvited && (
        <>
          <GoogleSignInButton onClick={onGoogleSignIn} disabled={loading} label="Continue with Google" />
          <AuthDivider />
        </>
      )}

      <form className="auth-form" onSubmit={onSubmit}>
        <div className="auth-field">
          <label>Work email</label>
          <input
            type="email"
            autoComplete="email"
            placeholder="you@company.com"
            value={form.email}
            onChange={(e) => setForm({ ...form, email: e.target.value })}
            // Email is locked to the invite address — if they need to use a
            // different inbox, they'll need a fresh invite from their admin.
            readOnly={isInvited}
            required
          />
          {isInvited && (
            <span className="auth-field-hint">
              Invites are email-specific. If you need a different address, ask your admin for a new invite.
            </span>
          )}
        </div>

        <div className="auth-field">
          <label>Password</label>
          <input
            type="password"
            autoComplete="new-password"
            placeholder="At least 10 characters"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            required
            minLength={10}
          />
          <PasswordStrengthHint value={form.password} />
        </div>

        {error && (
          <div className="error-message">
            <span></span> {error}
          </div>
        )}

        <button type="submit" className="generate-btn ready" disabled={loading}>
          <span className="btn-icon"></span>
          <span className="btn-text">{loading ? 'Creating account…' : 'Continue'}</span>
        </button>
      </form>

      <button className="auth-toggle" onClick={onSwitchToLogin}>
        Already have an account? Sign in
      </button>
    </div>
  );
}
